module.exports = __webpack_public_path__ + "static/media/The-West-App_Desktop-Banner-906x212px.02f20704.png";